import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import { locationApi } from '@/services/api/locations-api'
import { LocationsApiCountriesRequest } from '@itsrever/returns-api-types'

export const countriesQuery = ({
  ecommerceID
}: Partial<LocationsApiCountriesRequest>) =>
  queryOptions({
    queryKey: ['countries', ecommerceID],
    queryFn:
      ecommerceID !== undefined
        ? async () => {
            const { data } = await locationApi.countries({
              ecommerceID
            })

            return data
          }
        : skipToken,
    staleTime: Infinity
  })

export const useCountries = ({
  ecommerceID
}: Partial<LocationsApiCountriesRequest>) => {
  return useQuery(countriesQuery({ ecommerceID }))
}
